import ProductClass from 'models/Product';

/**
 * Hold information about a Product Family
 */

class ProductFamily {
	constructor(productFamily = {}) {
		this.benefits = productFamily.benefits;
		this.description = productFamily.description;
		this.maxPrice = productFamily.maxPrice;
		this.minPrice = productFamily.minPrice;
		this.attributes = productFamily.productAttributes || productFamily.attributes;
		this.members = productFamily.productFamilyMembers || productFamily.members;
		this.parentCategoryId = productFamily.parentCategoryId;
		this.products = productFamily.products;
		this.sku = productFamily.id;
	}

	/**
	 * Return the best matching product and the product's attribute values
	 * based on the selected attribute values
	 * @param {string} key the selected attribute value key
	 * @param {object} selectedValues the desired attribute value for a product
	 */
	findProduct(key, selectedValues) {
		const selectedAttribute = selectedValues.find(element => element.Key === key);
		const numberOfAttributes = this.attributes.length;
		let selectedMemberIndex = -1;
		let foundFirstMatch = false;
		let firstMatchingProductIndex = -1;
		let firstMatchingValues = [];

		const foundProduct = this.members.some(
			// loop through members to find a match
			member => {
				// if there's no perfect match, then let's use the first match based on the attribute key
				if (!foundFirstMatch) {
					const checkMemberAttribute = member.attributeValues.find(
						checkAttribute => checkAttribute.Key === key,
					);
					if (checkMemberAttribute.Value === selectedAttribute.Value) {
						foundFirstMatch = true;
						firstMatchingProductIndex = this.products.findIndex(
							productMember => member.productId === productMember.sku,
						);
						firstMatchingValues = member.attributeValues;
					}
				}

				// loop through member attributes to find a matching product
				const score = member.attributeValues.reduce((holdScore, currAttribute) => {
					// compare each member attribute to selected values
					const selectedValue = selectedValues.find(selValue => selValue.Key === currAttribute.Key);
					if (
						currAttribute.Key === selectedValue.Key &&
						currAttribute.Value === selectedValue.Value
					) {
						// the key/value match so increase accumulator
						return holdScore + 1;
					}
					return holdScore;
				}, 0);

				if (score === numberOfAttributes) {
					// we found a matching product
					selectedMemberIndex = this.products.findIndex(
						productMember => member.productId === productMember.sku,
					);
					return true;
				}
				// did not find a perfect match
				return false;
			},
		);

		// return the best match based on the attribute value key
		if (foundProduct) {
			const matchingProduct = this.products[selectedMemberIndex];
			return {
				index: selectedMemberIndex,
				product: new ProductClass(matchingProduct.id, matchingProduct),
				selectedValues,
			};
		}
		const firstMatchingProduct = this.products[firstMatchingProductIndex];
		return {
			index: firstMatchingProductIndex,
			product: new ProductClass(firstMatchingProduct.id, firstMatchingProduct),
			selectedValues: firstMatchingValues,
		};
	}
}

export default ProductFamily;
